import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { CSpinner } from '@coreui/react';

// Components ko import karein (Raste sahi check karein)
import Login from './views/pages/Login'; 
import Register from './views/pages/Register';
import MembershipLayout from './layout/MembershipLayout'; // Bina { } ke hona chahiye
import MembershipStore from './views/membership/MembershipStore';
import Home from './views/membership/Home';
import CourseDetails from './views/membership/CourseDetails';
// CoreUI CSS zaroori hai
import '@coreui/coreui/dist/css/coreui.min.css';
import ViewQuestion from './views/membership/ViewQuestion';
import DownloadPDF from './components/DownloadPDF';
import CoursePage from './views/membership/CoursePage';
import QuestionBank from './views/membership/QuestionBank';

const App = () => {
  return (
    <BrowserRouter>
      {/* Suspense ka use karein taaki loading smooth ho */}
      <Suspense fallback={<CSpinner color="primary" />}>
      <Routes>
        {/* Auth Pages */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Layout Wrapper */}
        <Route element={<MembershipLayout />}>
               <Route path="/" element={<Home/>} />
          <Route path="/membership" element={<MembershipStore />} />
          {/* <Route path="/:section/:title" element={<CourseDetails />} /> */}
         <Route path="/:section/:title" element={<QuestionBank />} />
          <Route path="/content/view-question/:id" element={<ViewQuestion/>} />
          <Route path="/content/download-pdf/:id" element={<DownloadPDF />} />
          <Route path="/" element={<Navigate to="/" replace />} />
          <Route path="/course/:courseName" element={<CoursePage />} />
           {/* <Route path="/course/:courseName" element={<QuestionBank />} /> */}
            {/* <Route path="/question" element={<QuestionBank />} /> */}
          
           
        </Route>
      </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;